<template>
  <div>
    <div class="chart-box-top">
      <span class="chart-title">国际运输航空致命事故数（年度）</span>
      <div class="chart-select-container">
        <el-button size="mini" type="primary" @click="onImportClick">导入</el-button>
      </div>
    </div>
    <div ref="chart" class="chart-main">
    </div>
    <el-dialog title="明细列表" :visible.sync="detailVisible" width="95%">
      <AccidentDetail ref="detail" :year="barYear"></AccidentDetail>
    </el-dialog>
    <el-dialog title="导入数据" :visible.sync="importData.visible" width="30%">
      <div ref="importWrap">
        <el-upload
          ref="importUploader"
          action="/sms/repo/result/accident/import"
          :before-upload="beforeUpload"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
          :on-success="handleSuccess"
          :on-error="handleError"
          :file-list="importFiles">
          <el-button size="small" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">
            <div>模板下载：
              <el-link type="primary" href="/resource/civil_aviation_event_template.xlsx">民航事件信息库导入模板.xlsx</el-link>
            </div>
          </div>
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";
import AccidentDetail from "./AccidentDetail";
import {showMessage} from "../../../utils/notice";
import {Loading} from "element-ui";

export default {
  props: {
    year: Number,
    reload: Boolean,
  },
  data() {
    return {
      xAxisData: [],
      accidentNum: [],
      deathToll: [],
      //是否显示明细列表
      detailVisible: false,
      //用户点击的年份
      barYear: null,
      chart: null,
      importData: {
        visible: false,
        files: [],
        loading: null,
      },
      importFiles: [],
    }
  },
  mounted() {
    this.buildChart();
    window.addEventListener('resize', () => {
      this.chart && this.chart.resize()
    })
  },
  watch: {
    year() {
      this.buildChart();
    },
  },
  methods: {
    onImportClick() {
      this.importData.visible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeUpload(file) {
      this.importData.loading = Loading.service({target: this.$refs.importWrap, customClass: "sms-loading"});
    },
    handleSuccess(response, file, fileList) {
      this.importData.loading && this.importData.loading.close();
      if (response.success) {
        showMessage("导入成功，信息：" + response.data, "success")
        this.importData.visible = false;
        this.$refs.importUploader.clearFiles();
        this.buildChart();
        this.$emit("update:reload", !this.reload);
      } else {
        showMessage("导入失败，异常信息：" + response.message, "error")
      }
    },
    handleError(err, file, fileList) {
      this.importData.loading && this.importData.loading.close();
      showMessage("导入失败，未知错误，请联系管理员处理", "error")
    },
    /**
     * 国际运输航空致命事故数（年度）
     */
    buildChart() {
      getRequest("/result/accident/chart/annual", {
        endYear: this.year
      }, this.$refs.chart).then(res => {
        this.xAxisData = [];
        this.accidentNum = [];
        this.deathToll = [];

        res.data.forEach(item => {
          this.xAxisData.push(item.year + "年");
          this.accidentNum.push({value: item.fatalAccidentCount, full: item});
          this.deathToll.push({value: item.deathToll, full: item});
        })

        this.chart = this.$echarts.init(this.$refs.chart);
        this.chart.setOption(this.getOption());

        this.chart.on("click", "series.bar", params => {
          this.barYear = params.data.full.year;
          this.detailVisible = true;
          this.$refs.detail && this.$refs.detail.initPage();
        })

        this.$util.adjustYaxis(this.chart, this.$util.getMax(this.deathToll));
      })
    },
    getOption() {
      return {
        xAxis: {
          data: this.xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
          axisLabel: {
            color: "#bebebe",
            fontSize: 11,
            interval: 0,
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 34,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          padding: [5, 10],
          confine: true
        },
        yAxis: [
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe",
              fontSize: 12,
            },
            name: "起",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"起"字与左y轴对齐
              align: "right",
              padding: [0, 5, 0, 0]
            },
          },
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe",
              fontSize: 12,
            },
            name: "人",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"人"字与右Y轴对齐
              align: "left",
              padding: [0, 0, 0, 15]
            },
          },
        ],
        legend: {
          itemWidth: 12,
          itemHeight: 12,
        },
        series: [
          {
            name: "致命事故数",
            smooth: true,
            type: "bar",
            symbol: "none",
            itemStyle: {
              normal: {
                color: "#198AFF",
              },
            },
            barWidth: 12,
            data: this.accidentNum,
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          },
          {
            name: "事故死亡人数",
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#F7B400",
                lineStyle: {
                  color: "#F7B400",
                  width: 2,
                },
              },
            },
            type: "line",
            symbol: "circle",
            symbolSize: "5",
            data: this.deathToll,
            animationDuration: 1000,
            animationEasing: "quadraticOut",
          }
        ],
      };
    },
  },
  components: {
    AccidentDetail
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/achievement/result/AccidentAnnual.vue